// extracted by mini-css-extract-plugin
export var externalLink = "_d0-0";
export var internalLinkLabel = "_d0-1";